module.exports = __webpack_public_path__ + "img/pt5.78abe747.png";